import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutCustomer } from "../../../services/Api";
import { loggedOut } from "../../../redux-setup/reducers/auth";
const Header = () => {
  const [keyword, setKeyword] = React.useState(null);
  const login = useSelector(({ auth }) => auth.login);
  // console.log("login");
  // console.log(login);

  const customerId = login.currentCustomer?._id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const changeKeyword = (e) => {
    setKeyword(e.target.value);
  };
  const clickSearch = (e) => {
    e.preventDefault();
    return navigate(`/Search?keyword=${keyword}`);
  };
  //Redux Toolkit
  const totalCart = useSelector(({ cart }) =>
    cart.items.reduce((total, item) => total + item.qty, 0)
  );
  const clickLogout = (e) => {
    e.preventDefault();
    dispatch(loggedOut());
    logoutCustomer()
      .then(() => navigate("/"))
      .catch((error) => console.log(error));
  };
  return (
    <>
      {/*	Header	*/}
      <div id="header">
        <div className="container">
          <div className="row">
            <div id="logo" className="col-lg-3 col-md-12 col-sm-12">
              <h1>
                <Link to="/">
                  <img className="img-fluid" src="images/logo.png" />
                </Link>
              </h1>
            </div>
            <div id="search" className="col-lg-4 col-md-12 col-sm-12">
              <form className="form-inline">
                <input
                  className="form-control mt-3"
                  type="search"
                  placeholder="Tìm kiếm"
                  aria-label="Search"
                  onChange={changeKeyword}
                  value={keyword}
                />
                <button
                  className="btn btn-danger mt-3"
                  type="submit"
                  onClick={clickSearch}
                >
                  Tìm kiếm
                </button>
              </form>
            </div>
            <div id="cart" className="col-lg-5 col-md-12 col-sm-12">
              <i className="fa-solid fa-user mr-1" />
              {login?.logged ? (
                <>
                  <Link className="mr-2" to="/Customer">
                    {login.currentCustomer.fullName}
                  </Link>
                  |
                  <Link
                    onClick={clickLogout}
                    className="mr-2 ml-2"
                    to="/Register"
                  >
                    đăng xuất
                  </Link>
                </>
              ) : (
                <>
                  <Link className="mr-2" to="/Login">
                    đăng nhập
                  </Link>
                  |
                  <Link className="mr-2 ml-2" to="/Register">
                    đăng ký
                  </Link>
                </>
              )}
              |
              <Link className="mt-4 mr-2 ml-2">
                giỏ hàng
                <ul>
                  <li>
                    <Link to="/Cart">
                      <i className="fas fa-shopping-cart" /> Giỏ hàng của bạn
                    </Link>
                  </li>
                  <li>
                    <Link to="/OrderList">
                      <i className="fas fa-file-alt" /> Đơn hàng đã mua
                    </Link>
                  </li>
                </ul>
              </Link>
              <span className="mt-3">{totalCart}</span>
            </div>
          </div>
        </div>
        {/* Toggler/collapsibe Button */}
        <button
          className="navbar-toggler navbar-light"
          type="button"
          data-toggle="collapse"
          data-target="#menu"
        >
          <span className="navbar-toggler-icon" />
        </button>
      </div>
      {/*	End Header	*/}
    </>
  );
};
export default Header;
